import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Равенство",
  "lead": "Во всем мире наблюдается прогресс на пути к гендерному равенству в образовании, однако разрыв между жителями сельской местности и городов, а также между богатыми и бедными по-прежнему велик."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, HighlightByIndex, IndicatorReference, PageLink, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky, Tooltip} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!PageLink) _missingMdxReference("PageLink", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  if (!Tooltip) _missingMdxReference("Tooltip", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_EQUITY"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "Желание никого не оставить в стороне пересекается с целями в области устойчивого развития (ЦУР) и четко выражено в пятой задаче в рамках ЦУР 4. Данный подход гарантирует, что лица, ответственные за разработку политики, в первую очередь уделяют внимание оказанию помощи наиболее отстающим."
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Возможность отслеживать сокращение разрывов в образовании обусловлена наличием данных в разбивке ", _jsx(_components.strong, {
        children: "по доходу, полу, возрасту, расе, этнической принадлежности, миграционному статусу, инвалидности, географическому положению и другим характеристикам"
      }), ", имеющих отношение к национальному контексту и полученных в результате обследований домохозяйств."]
    }), "\n", _jsxs(_components.p, {
      children: ["С 2010 года ", _jsx(_components.a, {
        href: "https://www.education-inequalities.org/",
        children: "Всемирная база данных по неравенству в области образования"
      }), " использует обследования домохозяйств с целью показать, насколько велик разрыв в образовании в разных странах. Здесь обобщены некоторые ключевые факты и тенденции неравенства в образовании, а некоторые дополнительные аспекты обсуждаются на странице, посвященной ", _jsx(PageLink, {
        name: "finance",
        children: "финансированию"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "пол",
      children: "Пол"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.5.1",
      children: [_jsxs(_components.p, {
        children: ["На графиках ниже показан разрыв в образовании между такими группами, как девочки и мальчики или бедные и богатые. Он измеряет разрыв в образовании с помощью", _jsx(Tooltip, {
          title: "Индекса паритета",
          content: "В индексе паритета, если значение близко к 0, это означает, что группа, находящаяся в неблагоприятном положении, очень сильно отстает; значения, близкие к 1, указывают на паритет; значения, близкие к 2, означают, что группа, находящаяся в благоприятном положении, отстает больше всего. Например, индекс паритета 0,5 может означать, что в школу зачислено 30 % девочек и 60 % мальчиков, а индекс паритета 1,5 будет означать, что в школу зачислены 30 % мальчиков и 60 % девочек.",
          children: "индекс паритета"
        }), "."]
      }), _jsxs(_components.p, {
        children: ["Несмотря на недостаточную оценку, в прошлом поколении наблюдалось постоянное движение к", _jsx(Tooltip, {
          title: "Гендерный паритет",
          content: "Одинаковое количество мальчиков и девочек",
          children: "гендерному паритету"
        }), ". Во многих, в основном более богатых, частях мира число девочек и молодых женщин в школах и университетах превышает число мальчиков и молодых мужчин."]
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "GPITREND"
          })
        }), _jsx(ScrollySection, {
          id: "income,0",
          children: _jsxs(_components.p, {
            children: ["Кривая на графике ниже ", _jsx(HighlightByIndex, {
              index: "-1",
              children: "серой"
            }), " области, показывает, что зачисленных мальчиков или молодых мужчин больше, чем девочек."]
          })
        }), _jsx(ScrollySection, {
          id: "geo,1",
          children: _jsxs(_components.p, {
            children: ["В ", _jsx(HighlightByIndex, {
              index: "0",
              children: "странах Африки к югу от Сахары"
            }), " на каждые пять молодых мужчин, обучающихся в высших учебных заведениях, приходится менее четырех молодых женщин."]
          })
        }), _jsx(ScrollySection, {
          id: "geo,2",
          children: _jsxs(_components.p, {
            children: ["В 1990 году девочки как группа имели чрезвычайно низкий уровень охвата образованием в ", _jsx(HighlightByIndex, {
              index: "2",
              children: "странах Центральной и Южной Азии"
            }), ".\nОднако этим странам удалось достичь гендерного паритета в начальном и высшем образовании,\nв основном благодаря значительному прогрессу в Индии. В результате этого данный регион обогнал ", _jsx(HighlightByIndex, {
              index: "0",
              children: "страны Африки к югу от Сахары"
            }), " в достижении гендерного паритета."]
          })
        })]
      }), _jsx(_components.p, {
        children: "Во всем мире с 2000 года достигнут значительный прогресс. Однако при анализе данных на страновом уровне выявляются сохраняющиеся пробелы: лишь две из трех стран достигли гендерного паритета в зачислении в начальную школу, менее одной из двух стран — в младшие классы средней школы и одной из пяти стран – в старшие классы средней школы."
      }), _jsxs(_components.p, {
        children: ["Доля стран со ", _jsx(HighlightByIndex, {
          index: "2",
          children: "значительным неравенством за счет девочек"
        }), " сократилась по меньшей мере вдвое в начальном и высшем образовании с 2000 года, однако остается на уровне 3 % в начальной школе, 6 % в младших классах средней школы и 12 % в старших классах средней школы."]
      }), _jsxs(_components.p, {
        children: ["Однако мы не должны забывать и о мальчиках, когда говорим о гендерном равенстве. Хотя страны реже имеют ", _jsx(HighlightByIndex, {
          index: "0",
          children: "большое неравенство за счет мальчиков"
        }), " в начальном образовании, оно гораздо чаще встречается в старших классах средней школы и на последующих ступенях образования."]
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "PARITYCOUNT"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["На этом графике, чем длиннее и темнее синяя часть полосы, тем больше стран с ", _jsx(HighlightByIndex, {
              index: "0",
              children: "большим количеством мальчиков, не посещающих школу"
            }), " чем девочек. Чем длиннее и темнее зеленая часть полосы, тем больше стран с ", _jsx(HighlightByIndex, {
              index: "2",
              children: "большим количеством девочек, не посещающих школу"
            }), ", чем мальчиков."]
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["Например, в высшем образовании почти две трети стран имеют ", _jsx(HighlightByIndex, {
              index: "0",
              children: "четко выраженное неравенство за счет мальчиков"
            }), "."]
          })
        })]
      }), _jsx(_components.h2, {
        id: "благосостояние",
        children: "Благосостояние"
      }), _jsx(_components.p, {
        children: "Обследования домохозяйств помогают выявить, что в целом разрыв в образовании между девочками и мальчиками не такой большой, как между жителями сельской и городской местности, а также между богатыми и бедными."
      }), _jsxs(_components.p, {
        children: ["Например, в Бангладеш, полное начальное образование имеют 92 % ", _jsx(HighlightByIndex, {
          index: "0",
          children: "самых богатых людей"
        }), "и только 70 % ", _jsx(HighlightByIndex, {
          index: "1",
          children: "самых бедных людей"
        }), ". В Нигерии неполное среднее образование имеют 94 % самых богатых людей и только 27 % самых бедных людей."]
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "PSECWGAP"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["Красными точками показано, какой процент детей или молодежи", _jsx(HighlightByIndex, {
              index: "1",
              children: "из самых бедных семей"
            }), " посещают школу по сравнению со сверстниками из ", _jsx(HighlightByIndex, {
              index: "0",
              children: "самых богатых семей"
            }), " (показано синим цветом). Вы можете изменить уровень образования с начального на неполное среднее образование и выше в верхней части графика."]
          })
        }), _jsx(ScrollySection, {
          id: "SRB",
          children: _jsxs(_components.p, {
            children: ["В сфере высшего образования наиболее существенный разрыв в странах со средним уровнем дохода. Например, в ", _jsx(_components.strong, {
              children: "Сербии"
            }), " 77 % самых богатых, но менее 28 % самых бедных людей посещали любую форму послешкольного образования."]
          })
        }), _jsx(ScrollySection, {
          id: "COL",
          children: _jsxs(_components.p, {
            children: ["В ", _jsx(_components.strong, {
              children: "Колумбии"
            }), " соответствующие показатели составляли 64 % и 7 %."]
          })
        })]
      }), _jsx(_components.p, {
        children: "Еще более показательным станет изучение изменений этих разрывов на протяжении всей учебы."
      }), _jsxs(_components.p, {
        children: ["Исследование ", _jsx(_components.strong, {
          children: "гендерного"
        }), " неравенства в ", _jsx(HighlightByIndex, {
          index: "0",
          children: "Бенине"
        }), " показывает, с повышением уровня образования растет количество девочек, бросающих школу."]
      }), _jsxs(_components.p, {
        children: ["С другой стороны, при выборе параметра ", _jsx(_components.strong, {
          children: "благосостояние"
        }), " показан разрыв, накапливаемый в ходе образовательной траектории за счет самых бедных, при этом едва ли кто-то из них продолжает обучение после старших классов средней школы."]
      }), _jsx(Figure, {
        id: "WLGPI"
      })]
    }), "\n", _jsx(_components.p, {
      children: "Ребенок редко попадает в одну категорию, поэтому крайне важно учитывать, как индивидуальные характеристики, такие как пол, взаимодействуют с такими характеристиками, как благосостояние, что показано на следующем графике."
    }), "\n", _jsxs(_components.p, {
      children: ["В странах Африки к югу от Сахары разрыв между ", _jsx(HighlightByIndex, {
        index: "1",
        children: "самыми бедными"
      }), " и ", _jsx(HighlightByIndex, {
        index: "0",
        children: "самыми богатыми"
      }), " увеличивается по мере перехода на более высокие ступени образования: на каждые 100 мальчиков, получающих высшее образование, приходится менее 35 девочек из самых бедных семей, по сравнению с почти 100 девочками из самых богатых семей."]
    }), "\n", _jsx(_components.p, {
      children: "С другой стороны, в Восточной и Юго-Восточной Азии точки движутся вверх от серой линии, поскольку гендерный разрыв возникает за счет мальчиков из беднейших слоев населения. Что касается уровня высшего образования, то у самых богатых девушек вероятность поступления в высшее учебное заведение всего на 35 % выше, чем у их сверстников, а у самых бедных девушек – на 50 % выше."
    }), "\n", _jsx(Figure, {
      id: "GPIBYWEALTH"
    }), "\n", _jsx(_components.h2, {
      id: "заключение",
      children: "Заключение"
    }), "\n", _jsx(_components.p, {
      children: "Существует неприемлемый уровень неравенства в образовании между странами и между группами внутри стран. Высококачественные дезагрегированные данные являются необходимым условием для разработки соответствующих стратегий по сокращению неравенств и, в конечном итоге, с целью никого не оставить в стороне в нашем стремлении к достижению ЦУР 4."
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.education-inequalities.org/",
            children: "Worldwide Inequalities Database on Education (WIDE)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.unesco.org/gem-report/en/2024genderreport",
            children: "Технологии на ее условиях — Всемирный доклад по мониторингу образования за 2024 год, посвященный вопросам гендерного равенства"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.savethechildren.org.uk/content/dam/gb/reports/policy/still-left-behind-low-res.pdf",
            children: "Все еще остаются позади — Save the Children"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
